<template>
  <section v-if="videosList.length" class="my-16 px-4 max-w-screen-4xl mx-auto">
    <h2>Recomendado</h2>

    <VideosList>
      En estos momentos no hay ningún vídeo destacado.
    </VideosList>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import VideosList from '@/components/VideosList'

export default {
  components: { VideosList },

  computed: {
    ...mapState('videos', ['videosList']),
  },

  mounted() {
    this.$store.dispatch('videos/fetchFeaturedVideos')
  },
}
</script>
